import { Component, Watch } from 'vue-property-decorator';
import Superbutton from 'tivigi/src/components/Superbutton/Superbutton'
import BarDisplay from 'tivigi/src/components/BarDisplay/BarDisplay'
import SM2Base from '../SM2Base';
import FloatingWindow from 'tivigi/src/components/FloatingWindow/FloatingWindow'
import WithRender from './Dynamik.html';

@WithRender
@Component({
    components: {BarDisplay,  Superbutton , FloatingWindow}
})
export default class Dynamik extends SM2Base {

    min: number = 0;
    max: number = 0;

    indicator: any = null

    latestYear = 0

    get absMax(): number {
        let result = Math.max(Math.abs(this.min), Math.abs(this.max))

        if (isNaN(result)) {
            return 0
        }

        return result
    }

   

    @Watch('indicator')
    onIndicatorChange() {


        // NOTE: Here, the only difference to "Metropolregionen" is the spatialUnits
       
        this.latestYear = this.getLatestYear(this.spatialUnitsDynamik[0], this.indicator.code)
    
        if (this.latestYear == null) {
            console.log("latest year is null")
            return
        }
        
        //#################### BEGIN Update min/max #######################
        this.min = Number.MAX_VALUE;
        this.max = Number.MIN_VALUE;


        for (let su of this.spatialUnitsDynamik) {
            let val = this.getValue(su, this.indicator.code, this.latestYear)

            if (val === undefined || val == null || isNaN(val)) {
                continue
            }

            if (val < this.min) {
                this.min = val;
            }

            if (val > this.max) {
                this.max = val;
            }
        }
        
        //#################### END Update min/max #######################
    }


    get spatialUnitsDynamik() : Array<any> {
        let result = Array<any>()

        // Deutschland:
        result.push(this.getSpatialUnit("Z0050"))

        // Die 3 Länder:
        result.push(this.getSpatialUnit("Z0051"))
        result.push(this.getSpatialUnit("Z0052"))
        result.push(this.getSpatialUnit("Z0053"))

        // MRN:
        result.push(this.getSpatialUnit("Z0040"))


        result = result.concat(this.getSpatialUnits(['K']))
        return result
    }

    
}


